export enum NetworkState {
    Pending,
    Loading,
    Success,
    Error,
}